/** @jsx jsx */
import { Text } from '@bottlebooks/gatsby-theme-base';
import Link from '@bottlebooks/gatsby-theme-base/src/components/Link/Link';
import BaseHeader from '@bottlebooks/gatsby-theme-event/src/components/Layout/Header';
import { jsx } from 'theme-ui';
import HeaderLogo from './HeaderLogo';

export default function Header({ children, homePath, ...rest }) {
  return (
    <BaseHeader
      {...rest}
      isSticky={false}
      sx={{ display: 'block', height: ['auto', 'auto'] }}
    >
      <HeaderLogo href="http://oldvineproject.co.za/" />
      <Menu>
        <MenuItem href="http://oldvineproject.co.za/">Home</MenuItem>
        <MenuItem href="http://oldvineproject.co.za/history/">About</MenuItem>
        <MenuItem href="http://oldvineproject.co.za/overview/">
          Vineyards
        </MenuItem>
        <MenuItem to={homePath} isActive>
          Old Vine Wines
        </MenuItem>
        <MenuItem href="http://oldvineproject.co.za/membership/">
          Membership
        </MenuItem>
        <MenuItem href="http://oldvineproject.co.za/heritage-tours/">
          Heritage Tours
        </MenuItem>
        <MenuItem href="http://oldvineproject.co.za/news-2/">News</MenuItem>
        <MenuItem href="http://oldvineproject.co.za/contact-2/">
          Contact
        </MenuItem>
      </Menu>
    </BaseHeader>
  );
}

function Menu({ children }) {
  return (
    <Text
      as="ul"
      variant="small"
      sx={{
        display: 'flex',
        justifyContent: '',
        flex: '1',
        listStyle: 'none',
        margin: 0,
        padding: 0,
      }}
    >
      {children}
    </Text>
  );
}

function MenuItem({ to, href, children, isActive, ...rest }) {
  return (
    <li
      sx={{
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'center',
        position: 'relative',
        '::before': {
          content: '""',
          position: 'absolute',
          left: '-.5px',
          top: '50%',
          height: 24,
          maxHeight: '100%',
          borderRight: 'solid 1px',
          borderColor: 'rgba(17,17,17,0.14)',
          transform: 'translateY(-50%)',
        },
        ':first-of-type::before': { display: 'none' },
      }}
    >
      <Link
        to={to}
        href={href}
        sx={{
          font:
            'normal 300 15px / 19px "Lato", Helvetica, Arial, Verdana, sans-serif',
          color: isActive ? '#f7a70a' : 'text',
          textTransform: 'uppercase',
          transition: 'color 0.3s ease-out',
          paddingX: 18,
          paddingY: 2,
          marginY: -2,
          ':hover': {
            color: '#f7a70a',
          },
          ':hover span::before': {
            opacity: 1,
            transform: 'translateY(0)',
          },
        }}
        {...rest}
      >
        <span
          sx={{
            position: 'relative',
            '::before': {
              content: '""',
              position: 'absolute',
              width: '100%',
              opacity: isActive ? 1 : 0,
              transition: 'opacity .3s,transform .3s',
              transform: isActive ? 'translateY(0)' : 'translateY(10px)',
              bottom: '-3px',
              height: 2,
              background: '#f7a70a',
            },
          }}
        >
          {children}
        </span>
      </Link>
    </li>
  );
}
